import { View } from 'react-native';
import type { DividerProps } from './types';
import { Flex } from '@banhala/ui-kit';

export const Divider = ({ entity }: DividerProps) => {
  return (
    <Flex.Column>
      {entity?.map((divider, i) => {
        return (
          <View
            key={i}
            style={{
              height: divider.item.height,
              backgroundColor: divider.item.color,
            }}
          />
        );
      })}
    </Flex.Column>
  );
};
